import * as React from "react";

import {
    Box,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { Checkbox, useTheme } from "@material-ui/core";

function EnhancedContactEventHead(props) {
    const {
        order,
        orderBy,
        onRequestSort,
        headCells,
        visibleColumns,
        customerCount,
        rowCount,
        handleCheckboxAllClick } = props;

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    const location = window.location.pathname.split("/").filter(Boolean);
    const detailPath = location.filter(p => isNaN(p)).join("/");
    const isActivePath = location.slice(0, 2).join("/");
    const theme = useTheme();
    return (
        <TableHead style={{ position: "sticky", top: 0, zIndex: 8 }}>
            <TableRow className="stickyCell stickyFirst">

                {headCells.filter((col) => visibleColumns?.includes(col?.id)).map((headCell, index) => {
                    // decide sticky class
                    const classes = [""]; // default no class
                    if (headCell.id === "action") classes.push("stickyCell", "stickyLast"); // last col by id
                    return headCell?.activeIndexOnly ? (
                        <TableCell
                            key={index}
                            align={headCell.align}
                            style={{ minWidth: headCell.minWidth }}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ background: theme.palette.thead, color: theme.palette.listItem }}
                            className={classes.join(" ")}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                disabled={!headCell.sortable}
                                direction={orderBy === headCell.id ? order : "asc"}
                                onClick={createSortHandler(headCell.id)}
                                sx={{
                                    '&.Mui-active': {
                                        color: theme.palette.listItem, // Change this to your desired active color
                                    },
                                    '& .MuiTableSortLabel-icon': {
                                        color: theme.palette.listItem, // Icon color
                                    }

                                }}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box sx={visuallyHidden}>
                                        {order === "desc" ? "sorted descending" : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ) : (
                        <TableCell
                            key={index}
                            align={headCell.align}
                            style={{ minWidth: headCell.minWidth }}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sx={{ background: theme.palette.thead }}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                disabled={!headCell.sortable}
                                direction={orderBy === headCell.id ? order : "asc"}
                                onClick={createSortHandler(headCell.id)}
                                sx={{
                                    '&.Mui-active': {
                                        color: theme.palette.listItem, // Change this to your desired active color
                                    },
                                    '& .MuiTableSortLabel-icon': {
                                        color: theme.palette.listItem, // Icon color
                                    }

                                }}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc" ? "sorted descending" : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead >
    );
}

export default EnhancedContactEventHead;
